import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'AllRfq',
  //   description: 'description of AllRfq',
  //   url: '/all-rfq',
  // },
];

export default help;
